<div class="header-content">
  <div class="left">
    <a class="logo" href="/">
      <img src="https://zip.co/assets/zip/logos/zip/primary.svg" alt="zip logo" />
    </a>
  </div>
  <div class="right">
    <div class="close-icon" (click)="close.emit()">
      <img
        async
        src="https://zip-co-media.s3-ap-southeast-2.amazonaws.com/icons/close-dark-blue.png"
      />
    </div>
  </div>
</div>
<div id="content" class="content" (scroll)="onScroll($event)">
  <ul class="sign-in-group" (click)="close.emit()">
    <li>
      <a href="{{ signinUrl }}"
        ><img
          async
          src="https://zip-co-media.s3-ap-southeast-2.amazonaws.com/icons/customer.png"
          alt="go to"
        />
        Customer sign in</a
      >
    </li>
    <li>
      <a href="{{ merchantSigninUrl }}"
        ><img
          async
          src="https://zip-co-media.s3-ap-southeast-2.amazonaws.com/icons/merchant.png"
          alt="go to"
        />Merchant sign in</a
      >
    </li>
  </ul>
  <ul class="page-group" (click)="close.emit()">
    <li><a [href]="shopLink"> Shop</a></li>
    <li><a href="/how-zip-works"> How it works</a></li>
    <li><a href="/business"> I'm a business</a></li>
    <li><a href="https://help.zip.co"> Help</a></li>
    <li>
      <zip-co-country-switcher (dropDownIsOpened)="scrollDown()" (dropDownIsClosing)="scrollUp()">
      </zip-co-country-switcher>
    </li>
  </ul>
</div>
<section [class.add-shadow]="overflow">
  <a
    *ngIf="!showZipBiz"
    href="/create-an-account"
    (click)="close.emit()"
    class="mobile-menu-apply-btn"
  >
    Apply for
    <img
      async
      src="https://zip-co-media.s3-ap-southeast-2.amazonaws.com/zip-logo--white-text.svg"
    />
  </a>
  <a
    *ngIf="showZipBiz"
    href="{{ this.signUpUrl }}"
    (click)="close.emit()"
    class="mobile-menu-apply-btn"
  >
    Apply for
    <img
      async
      src="https://zip-co-media.s3-ap-southeast-2.amazonaws.com/zip-logo--white-text.svg"
    />
  </a>
</section>
